import { configureStore } from '@reduxjs/toolkit';
import combinedReducer from './combinedReducer';
import errorMiddleware from './middleware';

const store = configureStore({
  reducer: combinedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(errorMiddleware),
});

export default store;
